import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=4fecab38&scoped=true&"
import script from "./Destinations.vue?vue&type=script&lang=js&"
export * from "./Destinations.vue?vue&type=script&lang=js&"
import style0 from "./Destinations.vue?vue&type=style&index=0&id=4fecab38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecab38",
  null
  
)

export default component.exports